import { catchError } from 'rxjs';
import { StudentSelectedRequest, StudentService } from '../lib';
import { ToastService } from './toast/toast.service';
import { AfterViewInit, Component, OnDestroy, inject } from '@angular/core';
import { ExternaliFrameEvent } from './models/externaliFrameEvent';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements AfterViewInit, OnDestroy {
	toastService = inject(ToastService);
  searchErrorMessage:any;
  constructor(private studentService: StudentService) {
  }
  ngAfterViewInit(): void {
    window.addEventListener("message", this.handleClickToSmsEvent.bind(this), false);
  }
  ngOnDestroy(): void {
    window.removeEventListener("message", this.handleClickToSmsEvent.bind(this), false);
  }


  handleClickToSmsEvent = (event: Event) => {
    let message = event as MessageEvent;
    let clickToSmsEvent = message.data as ExternaliFrameEvent;
    if (clickToSmsEvent.eventType != "SMS") { return; }
    if (clickToSmsEvent.syStudentId != undefined) {
      let request = { syStudentId: clickToSmsEvent.syStudentId } as StudentSelectedRequest;
      this.swapToStudent(request).subscribe(() => {});
    }
  }
  swapToStudent = (req: StudentSelectedRequest) => {
    return this.studentService.apiStudentSelectedPost(req).pipe(
      catchError(error => {
        this.searchErrorMessage = 'Student Selection failed for click-to-SMS';
        return [];
      })
    );
  };
}
